"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.AccessoryImage = exports.AccessoryConfiguration = exports.AccessoryModelBuilder = exports.AccessoryModel = exports.AccessorySize = exports.AccessoryWeight = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var Design_1 = require("./Design");
var AccessoryWeight = /** @class */ (function () {
    function AccessoryWeight() {
    }
    AccessoryWeight.findAccessoryWeight = function (accessoryWeights, matchAccessoryConfiguration) {
        return accessoryWeights.find(function (p) {
            return AccessoryConfiguration.identical(p.configuration, matchAccessoryConfiguration);
        });
    };
    return AccessoryWeight;
}());
exports.AccessoryWeight = AccessoryWeight;
var AccessorySize;
(function (AccessorySize) {
    AccessorySize["SMALL"] = "SMALL";
    AccessorySize["MEDIUM"] = "MEDIUM";
    AccessorySize["LARGE"] = "LARGE";
})(AccessorySize = exports.AccessorySize || (exports.AccessorySize = {}));
var AccessoryModel = /** @class */ (function () {
    function AccessoryModel() {
    }
    AccessoryModel.isPublishable = function (accessoryModel) {
        return (AccessoryModel.hasDimensionsValid(accessoryModel) &&
            AccessoryModel.hasIconValid(accessoryModel) &&
            AccessoryModel.hasCadFileValid(accessoryModel) &&
            AccessoryModel.hasWeightsValid(accessoryModel) &&
            AccessoryModel.hasImagesValid(accessoryModel));
    };
    AccessoryModel.hasDimensionsValid = function (accessoryModel) {
        return core_common_domain_1.Dimensions3D.allDimensionsHigherThan(accessoryModel.dimensions, 0);
    };
    AccessoryModel.hasIconValid = function (accessoryModel) {
        return core_common_domain_1.Media.isValidWithContentType(accessoryModel.icon, core_common_domain_1.MimeType.SVG);
    };
    AccessoryModel.hasCadFileValid = function (accessoryModel) {
        return core_common_domain_1.Media.isValidWithContentType(accessoryModel.cadFile, core_common_domain_1.MimeType.GLB);
    };
    AccessoryModel.hasWeightsValid = function (accessoryModel) {
        var _loop_1 = function (availableConfig) {
            if (!accessoryModel.weights.find(function (w) { return AccessoryConfiguration.identical(w.configuration, availableConfig); })) {
                return { value: false };
            }
        };
        /* Check 1 - Each available configuration must have an associated weight */
        for (var _i = 0, _a = accessoryModel.availableConfigurations; _i < _a.length; _i++) {
            var availableConfig = _a[_i];
            var state_1 = _loop_1(availableConfig);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        /* Check 2 - Each weight must be a positive number */
        for (var _b = 0, _c = accessoryModel.weights; _b < _c.length; _b++) {
            var weight = _c[_b];
            if (weight.weightInGrams <= 0)
                return false;
        }
        return true;
    };
    AccessoryModel.hasImagesValid = function (accessoryModel) {
        var _loop_2 = function (availableConfig) {
            if (!accessoryModel.images.find(function (i) { return AccessoryConfiguration.identical(i.configuration, availableConfig); })) {
                return { value: false };
            }
        };
        /* Check 1 - Each available configuration must have an associated image */
        for (var _i = 0, _a = accessoryModel.availableConfigurations; _i < _a.length; _i++) {
            var availableConfig = _a[_i];
            var state_2 = _loop_2(availableConfig);
            if (typeof state_2 === "object")
                return state_2.value;
        }
        /* Check 2 - Each image must be a valid media */
        for (var _b = 0, _c = accessoryModel.images; _b < _c.length; _b++) {
            var im = _c[_b];
            if (!core_common_domain_1.Media.isValidWithContentType(im.image.media, core_common_domain_1.MimeType.PNG))
                return false;
        }
        return true;
    };
    AccessoryModel.hasInconsistentState = function (accessoryModel) {
        for (var _i = 0, _a = accessoryModel.availableConfigurations; _i < _a.length; _i++) {
            var ac = _a[_i];
            if (ac.sizeType !== accessoryModel.sizeType)
                return {
                    consistent: false,
                    reason: "Available configuration " + JSON.stringify(ac) + " must be consistent with the accessory model " + JSON.stringify(accessoryModel) + " => sizeType=" + accessoryModel.sizeType
                };
        }
        for (var _b = 0, _c = accessoryModel.images; _b < _c.length; _b++) {
            var ac = _c[_b];
            if (ac.configuration.sizeType !== accessoryModel.sizeType)
                return {
                    consistent: false,
                    reason: "Available images configuration " + JSON.stringify(ac) + " must be consistent with the accessory model " + JSON.stringify(accessoryModel) + " => sizeType=" + accessoryModel.sizeType
                };
        }
        for (var _d = 0, _e = accessoryModel.weights; _d < _e.length; _d++) {
            var ac = _e[_d];
            if (ac.configuration.sizeType !== accessoryModel.sizeType)
                return {
                    consistent: false,
                    reason: "Available weights configuration " + JSON.stringify(ac) + " must be consistent with the accessory model " + JSON.stringify(accessoryModel) + " => sizeType=" + accessoryModel.sizeType
                };
        }
        return { consistent: true };
    };
    return AccessoryModel;
}());
exports.AccessoryModel = AccessoryModel;
var AccessoryModelBuilder = /** @class */ (function () {
    function AccessoryModelBuilder(accessoryModel) {
        this.accessoryModel = accessoryModel;
    }
    AccessoryModelBuilder.initialiseWithAccessoryModel = function (accessoryModel) {
        return new AccessoryModelBuilder(accessoryModel);
    };
    AccessoryModelBuilder.initialiseWithAccessoryModelUpdate = function (update, accessoryModelId) {
        return AccessoryModelBuilder.initialiseWithAccessoryModel({
            id: accessoryModelId ? accessoryModelId : core_common_logic_1.CommonLogic.generateUUIDv4(),
            cadFile: update.cadFile,
            sizeType: update.sizeType,
            dimensions: update.dimensions,
            icon: update.icon,
            availableConfigurations: update.availableConfigurations,
            weights: update.weights,
            images: update.images
        });
    };
    AccessoryModelBuilder.initialise = function (sizeType, dimensions, availableConfigurations, availableWeights) {
        return AccessoryModelBuilder.initialiseWithAccessoryModel({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            cadFile: core_common_domain_1.Media.UNDEFINED,
            sizeType: sizeType,
            dimensions: dimensions,
            icon: core_common_domain_1.Media.UNDEFINED,
            availableConfigurations: availableConfigurations,
            weights: availableWeights,
            images: []
        });
    };
    AccessoryModelBuilder.prototype.build = function () {
        return this.accessoryModel;
    };
    AccessoryModelBuilder.prototype.buildUpdate = function () {
        return {
            cadFile: this.accessoryModel.cadFile,
            sizeType: this.accessoryModel.sizeType,
            dimensions: this.accessoryModel.dimensions,
            icon: this.accessoryModel.icon,
            availableConfigurations: this.accessoryModel.availableConfigurations,
            weights: this.accessoryModel.weights,
            images: this.accessoryModel.images
        };
    };
    AccessoryModelBuilder.prototype.withId = function (accessoryModelId) {
        this.accessoryModel.id = accessoryModelId;
        return this;
    };
    AccessoryModelBuilder.prototype.getId = function () {
        return this.accessoryModel.id;
    };
    AccessoryModelBuilder.prototype.createOrReplaceAccessoryImage = function (newAccessoryImage) {
        if (this.hasAccessoryImage(newAccessoryImage.configuration)) {
            return this.deleteAccessoryImage(newAccessoryImage.configuration).createAccessoryImage(newAccessoryImage);
        }
        else {
            return this.createAccessoryImage(newAccessoryImage);
        }
    };
    AccessoryModelBuilder.prototype.hasAccessoryImage = function (accessoryConfiguration) {
        return (this.accessoryModel.images.find(function (image) {
            return AccessoryConfiguration.identical(image.configuration, accessoryConfiguration);
        }) !== undefined);
    };
    AccessoryModelBuilder.prototype.createAccessoryImage = function (newAccessoryImage) {
        if (this.hasAccessoryImage(newAccessoryImage.configuration))
            throw new core_common_domain_1.Exception("Cannot update the accessory model to add image with configuration " + newAccessoryImage.configuration + " because an image with an identican configuration is already inside the accessory model " + this.getId());
        this.accessoryModel.images.push(newAccessoryImage);
        return this;
    };
    AccessoryModelBuilder.prototype.deleteAccessoryImage = function (accessoryConfiguration) {
        if (!this.hasAccessoryImage(accessoryConfiguration))
            throw new core_common_domain_1.Exception("Cannot update the accessory model to remove image with configuration " + accessoryConfiguration + " because it cannot be found inside the accessory model " + this.getId());
        this.accessoryModel.images = this.accessoryModel.images.filter(function (image) { return !AccessoryConfiguration.identical(image.configuration, accessoryConfiguration); });
        return this;
    };
    AccessoryModelBuilder.prototype.withAccessoryModelUpdate = function (update) {
        this.accessoryModel = {
            id: this.accessoryModel.id,
            cadFile: update.cadFile ? update.cadFile : this.accessoryModel.cadFile,
            sizeType: update.sizeType ? update.sizeType : this.accessoryModel.sizeType,
            dimensions: update.dimensions ? update.dimensions : this.accessoryModel.dimensions,
            icon: update.icon ? update.icon : this.accessoryModel.icon,
            availableConfigurations: update.availableConfigurations
                ? update.availableConfigurations
                : this.accessoryModel.availableConfigurations,
            weights: update.weights ? update.weights : this.accessoryModel.weights,
            images: update.images ? update.images : this.accessoryModel.images
        };
        return this;
    };
    return AccessoryModelBuilder;
}());
exports.AccessoryModelBuilder = AccessoryModelBuilder;
var AccessoryConfiguration = /** @class */ (function () {
    function AccessoryConfiguration() {
    }
    AccessoryConfiguration.getAvailablePlatingTypes = function (accessoryConfigurations) {
        var platingTypes = new Set();
        for (var _i = 0, accessoryConfigurations_1 = accessoryConfigurations; _i < accessoryConfigurations_1.length; _i++) {
            var ac = accessoryConfigurations_1[_i];
            platingTypes.add(ac.platingType);
        }
        return platingTypes;
    };
    AccessoryConfiguration.getAvailableSizes = function (accessoryConfigurations) {
        var accessorySizes = new Set();
        for (var _i = 0, accessoryConfigurations_2 = accessoryConfigurations; _i < accessoryConfigurations_2.length; _i++) {
            var ac = accessoryConfigurations_2[_i];
            accessorySizes.add(ac.sizeType);
        }
        return accessorySizes;
    };
    AccessoryConfiguration.getAvailableMaterialTypes = function (accessoryConfigurations) {
        var materialTypes = new Set();
        for (var _i = 0, accessoryConfigurations_3 = accessoryConfigurations; _i < accessoryConfigurations_3.length; _i++) {
            var ac = accessoryConfigurations_3[_i];
            materialTypes.add(ac.materialType);
        }
        return materialTypes;
    };
    AccessoryConfiguration.identical = function (c1, c2) {
        return (c1.sizeType === c2.sizeType && c1.materialType === c2.materialType && c1.platingType === c2.platingType);
    };
    AccessoryConfiguration.generateAccessoryAvailability = function (sizes, materials, platings) {
        var result = [];
        sizes.forEach(function (sizeType) {
            materials.forEach(function (material) {
                platings.forEach(function (plating) {
                    result.push({
                        sizeType: sizeType,
                        materialType: material,
                        platingType: plating
                    });
                });
            });
        });
        return result;
    };
    AccessoryConfiguration.fullAccessoryAvailability = AccessoryConfiguration.generateAccessoryAvailability([AccessorySize.SMALL, AccessorySize.MEDIUM, AccessorySize.LARGE], [Design_1.MaterialType.SILVER], [Design_1.PlatingType.RHODIUM, Design_1.PlatingType.ROSE_GOLD, Design_1.PlatingType.YELLOW_GOLD]);
    return AccessoryConfiguration;
}());
exports.AccessoryConfiguration = AccessoryConfiguration;
var AccessoryImage = /** @class */ (function () {
    function AccessoryImage() {
    }
    AccessoryImage.withImageUrl = function (oldAccessoryImage, newImageUrl) {
        return __assign(__assign({}, oldAccessoryImage), { image: core_common_domain_1.Image.withUrl(oldAccessoryImage.image, newImageUrl) });
    };
    return AccessoryImage;
}());
exports.AccessoryImage = AccessoryImage;
